import { createApi } from '@reduxjs/toolkit/query/react';
import { MetaQuery } from '@refinedev/core';
import { overrideFetchBaseQuery } from '../utils/overrideFetchBaseQuery';
import { baseQueryWithZodValidation } from '../utils/baseQueryWithZodValidation';
import { CategoryDTOType } from '../../schemas/category';

export const categoryApi = createApi({
  reducerPath: 'categoryApi',
  baseQuery: baseQueryWithZodValidation(overrideFetchBaseQuery({}), {}),

  endpoints: builder => ({
    searchCategories: builder.query<
      Array<CategoryDTOType>,
      { query: any; page: number; size: number; meta?: MetaQuery }
    >({
      // * ################################################################
      query: ({ query, page, size, meta }) => ({
        url: `/category/search?page=${page}&size=${size}`,
        method: 'POST',
        body: { ...query, ...meta },
      }),
    }),

    // * ################################################################
  }),
});

export const { useLazySearchCategoriesQuery } = categoryApi;
